import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import UsuarioPerfilReducer from '../usuarioPerfil/usuarioPerfilReducer';
import UsuarioReducer from '../usuario/usuarioReducer';
import EmpresaReducer from '../empresa/empresaReducer';
import FornecedorReducer from '../fornecedor/fornecedorReducer';
import TipoProducaoReducer from '../tipoProducao/tipoProducaoReducer';
import FaseProducaoReducer from '../faseProducao/faseProducaoReducer';
import ParceiroReducer from '../parceiro/parceiroReducer';
import TransportadoraReducer from '../transportadora/transportadoraReducer';
import MotoristaReducer from '../motorista/motoristaReducer';
import VeiculoReducer from '../veiculo/veiculoReducer';
import MateriaPrimaReducer from '../materiaPrima/materiaPrimaReducer';
import UnidadeMedidaReducer from '../unidadeMedida/unidadeMedidaReducer';
import RacaoReducer from '../racao/racaoReducer';
import EquipamentoReducer from '../equipamento/equipamentoReducer';
import SolicitacaoReducer from '../solicitacao/solicitacaoReducer';
import ProducaoReducer from '../producao/producaoReducer';
import CargaReducer from '../carga/cargaReducer';
import ProducaoCargaReducer from '../producaoCarga/producaoCargaReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	dashboard: DashboardReducer,
	usuarioPerfil: UsuarioPerfilReducer,
	usuario: UsuarioReducer,
	empresa: EmpresaReducer,
	fornecedor: FornecedorReducer,
	tipoProducao: TipoProducaoReducer,
	faseProducao: FaseProducaoReducer,
	parceiro: ParceiroReducer,
	transportadora: TransportadoraReducer,
	motorista: MotoristaReducer,
	veiculo: VeiculoReducer,
	materiaPrima: MateriaPrimaReducer,
	unidadeMedida: UnidadeMedidaReducer,
	racao: RacaoReducer,
	equipamento: EquipamentoReducer,
	solicitacao: SolicitacaoReducer,
	producao: ProducaoReducer,
	carga: CargaReducer,
	producaoCarga: ProducaoCargaReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;
